<template>
  <div class="saas-listing-page">
    <div class="saas-page-head">
      <div class="saas-rounded-shape saas-rounded-shape__vertical-left-1"></div>
      <div class="saas-rounded-shape saas-rounded-shape__vertical-left-2"></div>
      <div class="saas-rounded-shape saas-rounded-shape__vertical-left-3"></div>
      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-1"
      ></div>
      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-2"
      ></div>
      <div
        class="saas-rounded-shape saas-rounded-shape__vertical-right-3"
      ></div>
      <h1 class="saas-page-head__title">
        Create with Baserow through <strong>videos</strong>
      </h1>
      <p class="saas-page-head__description">
        Get started with our library of guides and tips.
      </p>
      <TextSearchInput
        v-model="searchQuery"
        placeholder="Search videos"
      ></TextSearchInput>
    </div>
    <div ref="body" class="saas-listing-page__body">
      <div class="saas-listing-page__sidebar">
        <div class="saas-listing-page__sidebar-sticky">
          <div class="saas-listing-page__sidebar-small-title">Categories</div>
          <ul class="saas-listing-page__categories">
            <li class="saas-listing-page__categories-item">
              <a
                class="saas-listing-page__categories-link"
                :class="{
                  'saas-listing-page__categories-link--active':
                    selectedCategory === -1,
                }"
                @click="selectCategory(-1)"
                >All videos</a
              >
            </li>
            <li
              v-for="category in page.categories"
              :key="category.id"
              class="saas-listing-page__categories-item"
            >
              <a
                class="saas-listing-page__categories-link"
                :class="{
                  'saas-listing-page__categories-link--active':
                    selectedCategory === category.id && searchQuery === '',
                }"
                @click="selectCategory(category.id)"
                >{{ category.name }}</a
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="saas-listing-page__templates">
        <div v-if="searchQuery === ''">
          <div
            v-for="category in selectedCategories"
            :key="'category-' + category.id"
          >
            <h2 class="saas-listing-page__templates-title">
              {{ category.name }}
            </h2>
            <div class="saas-video-cards">
              <VideoCard
                v-for="video in getVideosOfCategory(category)"
                :key="'result-' + video.id"
                :video="video"
              ></VideoCard>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="saas-listing-page__templates-head">
            <h2 class="saas-listing-page__templates-title">
              Results for "{{ searchQuery }}"
            </h2>
            <Button type="secondary" @click="searchQuery = ''"
              >Clear search</Button
            >
          </div>
          <div v-if="searchResults.length === 0">
            <div class="placeholder">
              <div class="placeholder__title">No videos found</div>
              <p class="placeholder__content">
                Check your spelling, or try refining your search.
              </p>
              <div class="placeholder__action">
                <Button
                  size="large"
                  type="secondary"
                  @click="selectCategory(-1)"
                >
                  Back to all videos
                </Button>
              </div>
            </div>
          </div>
          <div v-else class="saas-video-cards">
            <VideoCard
              v-for="video in searchResults"
              :key="'result-' + video.id"
              :video="video"
            ></VideoCard>
          </div>
        </div>
      </div>
    </div>
    <FooterJoin></FooterJoin>
  </div>
</template>

<script>
import { escapeRegExp } from '@baserow/modules/core/utils/string'
import TextSearchInput from '@saas/components/TextSearchInput'
import FooterJoin from '@saas/components/footer/FooterJoin'
import VideoCard from '@saas/components/video/VideoCard'
import cmsPage from '@saas/mixins/cmsPage'

export default {
  components: { TextSearchInput, FooterJoin, VideoCard },
  mixins: [cmsPage],
  layout: 'saas',
  data() {
    return {
      searchQuery: '',
      selectedCategory: -1,
    }
  },
  computed: {
    selectedCategories() {
      let categories = this.page.categories
      if (this.selectedCategory !== -1) {
        categories = categories.filter(
          (category) => category.id === this.selectedCategory
        )
      }
      return categories
    },
    searchResults() {
      const allVideos = []
      const regex = new RegExp('(' + escapeRegExp(this.searchQuery) + ')', 'i')
      console.log(this.page.videos)
      this.page.videos.forEach((video) => {
        if (
          (video.title.match(regex) ||
            video.title.match(regex) ||
            video.short_description.match(regex)) &&
          allVideos.findIndex((result) => result.id === video.id) === -1
        ) {
          allVideos.push(video)
        }
      })
      return allVideos
    },
  },
  methods: {
    selectCategory(category) {
      this.searchQuery = ''
      this.selectedCategory = category
      this.$nextTick(() => {
        this.$refs.body.scrollIntoView({ behavior: 'smooth' })
      })
    },
    getVideosOfCategory(category) {
      return this.page.videos.filter(
        (video) => video.category_id === category.id
      )
    },
  },
}
</script>
